var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "b-col",
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "2",
                "label-align-md": "right"
              }
            },
            [
              _c("label", { staticClass: "font-weight-bold pt-0" }, [
                _vm._v(_vm._s(_vm.$t("Nimi")))
              ]),
              _vm._v(
                " " +
                  _vm._s(_vm.contract.Customer.FirstName) +
                  " " +
                  _vm._s(_vm.contract.Customer.LastName)
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "2",
                "label-align-md": "right"
              }
            },
            [
              _c("label", { staticClass: "font-weight-bold pt-0" }, [
                _vm._v(_vm._s(_vm.$t("Henkilötunnus")))
              ]),
              _vm._v(" " + _vm._s(_vm.contract.Customer.Pin))
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "2",
                "label-align-md": "right"
              }
            },
            [
              _c("label", { staticClass: "font-weight-bold pt-0" }, [
                _vm._v(_vm._s(_vm.$t("Puhelinnumero")))
              ]),
              _vm._v(" " + _vm._s(_vm.contract.Customer.Phone))
            ]
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "2",
                "label-align-md": "right"
              }
            },
            [
              _c("label", { staticClass: "font-weight-bold pt-0" }, [
                _vm._v(_vm._s(_vm.$t("Sähköpostiosoite")))
              ]),
              _vm._v(" " + _vm._s(_vm.contract.Customer.Email))
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0",
              attrs: {
                "label-cols-sm": "12",
                "label-cols-lg": "2",
                "label-align-md": "right"
              }
            },
            [
              _c("label", { staticClass: "font-weight-bold pt-0" }, [
                _vm._v(_vm._s(_vm.$t("Loppulaskun osoite")))
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", { staticStyle: { "white-space": "pre" } }, [
                _vm._v(_vm._s(_vm.lastInvoiceAddressString))
              ]),
              _c("br"),
              _vm._v(" "),
              _vm.contract.MoveOutProcess.FinalInvoicingAddress.Email
                ? _c("span", { staticStyle: { "white-space": "pre" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("Sähköpostiosoite:")) +
                        " " +
                        _vm._s(
                          _vm.contract.MoveOutProcess.FinalInvoicingAddress
                            .Email
                        )
                    )
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }